export enum OrderStatus {
  NONE = 1,
  COMPLETE = 2,
  DECLINED = 3,
  NOT_COMPLETE = 4, // Not complete, but not declined (user role not updated yet)
}
